import { i18n } from "@lingui/core";
import { Trans, t } from "@lingui/macro";
import React from "react";
import { useLocation } from "react-router";
import { useHistory } from 'react-router-dom';
import * as yup from "yup";
import { useYupValidationForm } from "../../common/hooks/useYupValidationForm";
import { DEFAULT_REDIRECT_URI } from "../../constants";
import { createOrg, registerOrg } from "../../util/APIUtils";
import { error, success } from "../../util/toast";
import ChangeLanguage from "../ChangeLanguage";
import { getDeviceInfo } from "../../util";

function useQuery() {
  const {search} = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const validationSchema = yup.object({
  orgName: yup
    .string()
    .trim()
    .required(`Không được để trống`)
    .max(50, `Tối đa 50 ký tự`),
  address: yup
    .string()
    .trim()
    .required(`Không được để trống`)
    .max(200, `Tối đa 200 ký tự`),
  taxCode: yup
    .string()
    .trim(`Không được để trống`)
    .max(50, `Tối đa 50 ký tự`),
});

const FormOrgSignUp = (props) => {
  const { step,tempRegisterKey, haveAccount } = props
  const {register, handleSubmit, formState: {errors}} = useYupValidationForm(validationSchema);
  const history = useHistory()
  let query = useQuery();
  const token = query.get("token")

  const onSubmit = async (data) => {
    const {deviceId,appVersion,deviceName} = await getDeviceInfo(query);
    if (!haveAccount) {
      data = {
        name: data.orgName,
        orgAddress: data.address,
        orgCode: data.taxCode,
        tempRegisterKey,
        deviceId,
        deviceName,
        appVersion,
      }
      registerOrg(data)
        .then(rs => {
          if (rs.ok){
            success(i18n._(t`Nhằm đảm bảo bảo mật. Hãy xác thực thông tin tài khoản của bạn qua mail.`))
            history.push('/sign-up-success')
          }
          else {
            error(i18n._(t`Vui lòng thử lại sau!`))
          }
        }).catch(err => {
        error((err && err.detail) || i18n._(t`Vui lòng thử lại sau!`))
      });
    } else {
      data = {
        name: data.orgName,
        orgAddress: data.address,
        orgCode: data.taxCode,
        deviceId,
        deviceName,
        appVersion,
      }
      createOrg(data,token)
        .then((rs) => {
          if (!rs.ok){
            throw new Error()
          }
          const redirect = DEFAULT_REDIRECT_URI
          const pathArr = redirect.split("/");
          const domain = pathArr.length > 3 ? `${pathArr[0]}//${pathArr[2]}` : redirect
          const stringQuery = new URLSearchParams()
          stringQuery.append('token', token)
          stringQuery.append('url', redirect)
          window.location.href = `${domain}/redirect?${stringQuery.toString()}`;
        }).catch(err => {
        error((err && err.detail) || i18n._(t`Vui lòng thử lại sau!`))
      });
    }
  }
  return (
    <div
      className={`${haveAccount ? 'min-h-[calc(100vh-110px)] md:min-h-screen' : (step === 3  ? 'min-h-[calc(100vh-110px)] md:min-h-screen' : 'h-0')} transition-all duration-300 bg-white overflow-hidden w-full z-0 px-2 relative`}>
      <button className="sm:absolute top-10 right-0">
          <ChangeLanguage />
        </button>
      <div className={'mt-14'}>
        <h1 className={'text-primary font-bold text-2xl sm:text-4xl'}>{!haveAccount ? t`Đăng ký tài khoản` : t`Đăng ký tổ chức`}</h1>
        <div className={`bg-primary h-1 rounded my-5 w-20`}/>
      </div>
      {!haveAccount ? <h1 className={'font-bold text-xl sm:text-2xl'}><Trans>Đăng ký tổ chức</Trans></h1> : ""}
      <form className={'flex flex-col'} onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className="flex flex-col items-center mt-10">
            <div className={'w-full sm:w-2/3 lg:w-1/2'}>
              <div className={`mb-2 font-semibold`}><span className={`text-red-500`}>*</span> <Trans>Tên tổ chức</Trans></div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.orgName ? 'border-red-500' : 'border-gray-300'}`}
                placeholder={t`Nhập tên tổ chức`}
                {...register('orgName')}
              />
              <div className={'text-right text-red-500 font-bold mr-2 mt-1 h-6 text-xs'}>
                {errors.orgName?.message ? i18n._(t`${errors.orgName.message}`) : <>&nbsp;</>}
              </div>
            </div>
            <div className={'w-full sm:w-2/3 lg:w-1/2'}>
              <div className={`mb-2 font-semibold`}><span className={`text-red-500`}>*</span> <Trans>Địa chỉ</Trans></div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.address ? 'border-red-500' : 'border-gray-300'}`}
                placeholder={t`Nhập địa chỉ`}
                {...register('address')}
              />
              <div className={'text-right text-red-500 font-bold mr-2 mt-1 h-6 text-xs'}>
                {errors.address?.message ? i18n._(t`${errors.address.message}`) : <>&nbsp;</>}
              </div>
            </div>
            <div className={'w-full sm:w-2/3 lg:w-1/2'}>
              <div className={`mb-2 font-semibold`}><Trans>Mã số thuế</Trans></div>
              <input
                className={`w-full py-2 px-5 rounded-md focus:ring outline-none border-2 ${errors.taxCode ? 'border-red-500' : 'border-gray-300'}`}
                placeholder={t`Nhập mã số thuế`} {...register('taxCode')}/>
              <div className={'text-right text-red-500 font-bold mr-2 mt-1 h-6 text-xs'}>
                {errors.taxCode?.message ? errors.taxCode.message : <>&nbsp;</>}
              </div>
            </div>
          </div>
        </div>
        <div className={'mx-auto py-5'}>
          <div className={`flex justify-center`}>
            <button className={'my-6 rounded group relative overflow-hidden'} type="submit">
              <div className={`text-white px-10 py-2 rounded bg-opacity-10 z-20 relative transition duration-300
                  flex items-center justify-center group-hover:text-primary border-2 border-primary h-full bg-primary`}>
                <Trans>Đăng ký</Trans>
              </div>
              <div className={`text-white w-full rounded bg-primary z-0 h-full
                  absolute bottom-0 right-0 group-hover:w-0 transition-all duration-300`}>
              </div>
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}
export default FormOrgSignUp;
